export type NetworkRoleObject = {
  networkRole: 'admin' | null;
  networkRoleUserId: number | null;
};

export async function fetchCurrentUserPodcastNetwork(): Promise<
  NetworkRoleObject
> {
  try {
    const response = await fetch('/api/currentnetwork', {
      method: 'GET',
      credentials: 'same-origin',
    });
    if (response.ok) {
      return await response.json();
    }
    throw new Error('Unable to fetch current user podcast network');
  } catch (err) {
    throw new Error(err.message);
  }
}
